import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Box as l } from "../../node_modules/@zillow/constellation-10/dist/components/box/box.esm.js";
import { Paragraph as d } from "../../node_modules/@zillow/constellation-10/dist/components/paragraph/paragraph.esm.js";
import { Text as y } from "../../node_modules/@zillow/constellation-10/dist/components/text/text.esm.js";
import { useFormContext } from "react-hook-form";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { useLastValidAmortizationValues } from "./AmortizationCalculator.utils.esm.js";
const AmortizationPaymentSummary = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidAmortizationValues(form);
  const baseCss = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "tighter",
    marginBottom: "tighter",
    width: "80%"
  };
  return /* @__PURE__ */ jsxs(_StyledBox, { "aria-live": "polite", "aria-atomic": "true", children: [
    /* @__PURE__ */ jsx(y, { asChild: true, textStyle: "heading-sm", "font-weight": "normal", children: /* @__PURE__ */ jsx("h2", { children: "Estimated monthly payment" }) }),
    /* @__PURE__ */ jsx(_StyledText, { textStyle: "heading-lg", children: getWholeDollars(lastValidValues.calculations.monthlyPayment) }),
    /* @__PURE__ */ jsxs(_StyledBox2, { $_css: baseCss, children: [
      /* @__PURE__ */ jsx(d, { children: "Total principal" }),
      /* @__PURE__ */ jsx(_StyledText2, { textStyle: "heading-sm", children: getWholeDollars(lastValidValues.calculations.totalPrincipal) })
    ] }),
    /* @__PURE__ */ jsxs(_StyledBox3, { $_css2: baseCss, children: [
      /* @__PURE__ */ jsx(d, { children: "Total interest" }),
      /* @__PURE__ */ jsx(_StyledText3, { textStyle: "heading-sm", children: getWholeDollars(lastValidValues.calculations.totalInterest) })
    ] }),
    /* @__PURE__ */ jsxs(_StyledBox4, { $_css3: baseCss, children: [
      /* @__PURE__ */ jsx(d, { children: "Principal & interest" }),
      /* @__PURE__ */ jsx(_StyledText4, { textStyle: "heading-sm", children: getWholeDollars(lastValidValues.calculations.totalPayment) })
    ] })
  ] });
};
var _StyledBox = styled(l)({
  flex: 1,
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  width: "100%",
  marginTop: "default"
});
var _StyledText = styled(y)({
  marginBottom: "default"
});
var _StyledBox2 = styled(l)((p) => ({
  ...p.$_css,
  borderBottom: "1px solid",
  borderColor: "border.muted"
}));
var _StyledText2 = styled(y)({
  color: "backgroundDarkGreen"
});
var _StyledBox3 = styled(l)((p) => ({
  ...p.$_css2,
  borderBottom: "1px solid",
  borderColor: "border.muted"
}));
var _StyledText3 = styled(y)({
  color: "aqua.500"
});
var _StyledBox4 = styled(l)`${(p) => p.$_css3}`;
var _StyledText4 = styled(y).withConfig({
  displayName: "AmortizationPaymentSummary___StyledText4",
  componentId: "sc-1nf6xr7-0"
})({
  color: "backgroundDarkPurple"
});
export {
  AmortizationPaymentSummary as default
};
